import { render, staticRenderFns } from "./vueSetEmiParametrs.vue?vue&type=template&id=5e4a8708&scoped=true"
import script from "./vueSetEmiParametrs.vue?vue&type=script&lang=js"
export * from "./vueSetEmiParametrs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4a8708",
  null
  
)

export default component.exports